import * as _ from 'underscore';

import { ActionTypes } from './actionTypes';

import { splitInLevels, getParentName, } from '../../Shared/index'
import { requestGet, } from '../../../modules/request/index';
import { Concept } from '../interfaces/concepts';

const conceptsEndpoint = `${window.postbuildEnv.DEFAULT_URL}/api/v1/concepts.json`;

export const startListeningToConcepts = () => {
  return (dispatch: Function) => {
    requestGet(conceptsEndpoint, (body) => {
      const concepts = splitInLevels(body.concepts);
      concepts['0'] = concepts['0'].map((concept: Concept) => {
        concept.displayName = `${getParentName(concept, concepts)} | ${concept.name}`;
        return concept;
      });
      dispatch({ type: ActionTypes.RECEIVE_CONCEPTS_DATA, data: concepts, });
    });
  };
}
